const STORAGE_KEY = "customGravingNotes";
const EXPIRATION_HOURS = 12;

function getStorageData() {
  const data = JSON.parse(localStorage.getItem(STORAGE_KEY));
  if (!data || !data.timestamp || !data.notes) return [];
  const now = Date.now();
  const diffHours = (now - data.timestamp) / (1000 * 60 * 60);
  if (diffHours > EXPIRATION_HOURS) {
    localStorage.removeItem(STORAGE_KEY);
    return [];
  }
  return data.notes;
}

function saveStorageData(notes) {
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      timestamp: Date.now(),
      notes,
    })
  );
}

function addOrUpdateNote(variantId, note) {
  const notes = getStorageData() || [];
  const existingIndex = notes.findIndex((item) => item.variantId === variantId);
  if (existingIndex !== -1) {
    notes[existingIndex].note = note; // Corregido: la propiedad es note
  } else {
    notes.push({ variantId, note });
  }
  saveStorageData(notes);
}

function deleteNote(variantId) {
  let notes = getStorageData() || [];
  notes = notes.filter((item) => item.variantId !== variantId);
  saveStorageData(notes);
}

window.addEventListener("DOMContentLoaded", () => {
  const buttonErase = document.querySelector(".knife-graving-modal__image-graving--button-erase");
  const textarea = document.querySelector(".knife-graving-modal__input");
  const idVariant = document.querySelector('[name="id"]').value;
  const text = document.querySelector(".knife-graving-modal__content-image--text");

  const existingNotes = getStorageData();
  if (existingNotes) {
    const existing = existingNotes.find((item) => item.variantId === idVariant);
    if (existing) {
      textarea.value = existing.note;
      text.textContent = existing.note;

      document.querySelector(".knife-graving-modal__image-no-graving--grabbed").style.display = "none";
      document.querySelector(".knife-graving-modal__image-no-graving--no-grabbed").style.display = "inline-block";

      const imageButton = document.querySelector(".knife-graving-modal__image-graving");
      const textVisible = document.querySelector(".knife-graving-modal__image-graving--custom-text");
      textVisible.textContent = existing.note;
      imageButton.classList.remove("knife-graving-modal__image-graving--hidden");
    }
  }

  textarea.addEventListener("input", () => {
    text.textContent = textarea.value;
  });

  document.querySelector(".knife-graving-button--save").addEventListener("click", () => {
    const idVariant = document.querySelector('[name="id"]').value;
    const textValue = text.textContent.trim();

    if (textValue.length === 0) {
      buttonErase.click();
      document.querySelector(".knife-graving-modal__toggle").click();
      return;
    }

    addOrUpdateNote(idVariant, textValue);

    document.querySelector(".knife-graving-modal__image-no-graving--grabbed").style.display = "none";
    document.querySelector(".knife-graving-modal__image-no-graving--no-grabbed").style.display = "inline-block";

    const imageButton = document.querySelector(".knife-graving-modal__image-graving");
    const textVisible = document.querySelector(".knife-graving-modal__image-graving--custom-text");
    textVisible.textContent = textValue;
    imageButton.classList.remove("knife-graving-modal__image-graving--hidden");

    document.querySelector(".knife-graving-modal__toggle").click();
  });

  document.querySelector(".knife-graving-button--erase").addEventListener("click", () => {
    const idVariant = document.querySelector('[name="id"]').value;
    deleteNote(idVariant);

    text.textContent = "";
    textarea.value = "";

    document.querySelector(".knife-graving-modal__image-no-graving--grabbed").style.display = "inline-block";
    document.querySelector(".knife-graving-modal__image-no-graving--no-grabbed").style.display = "none";

    const imageButton = document.querySelector(".knife-graving-modal__image-graving");
    const textVisible = document.querySelector(".knife-graving-modal__image-graving--custom-text");
    textVisible.textContent = "";
    imageButton.classList.add("knife-graving-modal__image-graving--hidden");
  });

  buttonErase.addEventListener("click", () => {
    const idVariant = document.querySelector('[name="id"]').value;
    deleteNote(idVariant);

    textarea.value = "";
    text.textContent = "";

    document.querySelector(".knife-graving-modal__image-no-graving--grabbed").style.display = "inline-block";
    document.querySelector(".knife-graving-modal__image-no-graving--no-grabbed").style.display = "none";

    const imageButton = document.querySelector(".knife-graving-modal__image-graving");
    const textVisible = document.querySelector(".knife-graving-modal__image-graving--custom-text");
    textVisible.textContent = "";
    imageButton.classList.add("knife-graving-modal__image-graving--hidden");
  });

  document.querySelector(".knife-graving-modal__toggle").addEventListener("click", () => {
    const idVariant = document.querySelector('[name="id"]').value;
    const existingNotes = getStorageData();
    if (existingNotes) {
      const existing = existingNotes.find((item) => item.variantId === idVariant);
      if (existing) {
        textarea.value = existing.note;
        text.textContent = existing.note;
      }
    }
  });

  document.querySelector('form[action*="/cart/add"]').addEventListener("submit", async function (e) {
    e.preventDefault();

    const variantId = document.querySelector('[name="id"]').value;
    const quantity = parseInt(document.querySelector('[name="quantity"]').value, 10) || 1;
    const gravingNote = document.querySelector(".knife-graving-modal__content-image--text").textContent.trim();

    try {
      // Añadir producto principal con propiedades personalizadas únicas para diferenciar líneas
      const productItem = {
        id: variantId,
        quantity,
        properties: {}
      };

      if (gravingNote.length > 0) {
        productItem.properties["_knifeGraving"] = gravingNote;
        productItem.properties["_customUniqueId"] = Date.now().toString();
      }

      const addResponse = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(productItem)
      });

      if (!addResponse.ok) throw new Error("Error al añadir el producto principal");

      if (gravingNote.length > 0) {
        const serviceItem = {
          id: "55553278345481", // ID del servicio de personalización (ajusta según tu tienda)
          quantity,
          properties: {
            "_relatedProduct": variantId,
            "_knifeGraving": gravingNote,
            "_customUniqueId": productItem.properties["_customUniqueId"]
          }
        };

        const serviceResponse = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(serviceItem)
        });

        if (!serviceResponse.ok) throw new Error("Error al añadir el servicio de personalización");
      }

      document.dispatchEvent(new CustomEvent("cart:refresh"));
      document.dispatchEvent(new CustomEvent("cart:open"));
    } catch (error) {
      console.error("Error al añadir al carrito:", error);
      alert("Hubo un problema al añadir el producto personalizado al carrito.");
    }
  });
});
